import axios from "axios";
import router from "@/router";
import store from "@/store"
import { Message } from 'element-ui';
import { logout } from '@/utils/auth'

// 根据正式环境或者测试环境使用不同url
export const testUrl = "https://erp.florina.cn:9443/api/v1";
export const onlineUrl = "https://erp.florina.cn:1443/api/v1";

let apiurl = process.env.NODE_ENV === "production" ? onlineUrl : testUrl;
axios.defaults.baseURL = apiurl;
// 超时设置
axios.defaults.timeout = 110000;
axios.interceptors.request.use(config => {
  // 在这里编写发送请求前的设置
  const TOKEN = localStorage.getItem('flo_token')?JSON.parse(localStorage.getItem('flo_token')):false
  if (TOKEN) {
    config.headers.Authorization = TOKEN;
    config.headers["Accept-Language"] = "zh-CN";
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response.data.status
    const message = error.response.data.message
    const TOKEN = localStorage.getItem('flo_token')?JSON.parse(localStorage.getItem('flo_token')):false
    if(TOKEN){
      if(status === 401){
        logout()
        router.push({
          path:'/login'
        })
        Message.error(message)
        return false
        // router.push('/401')
      }else if(status === 404){
        Message.error(message)
        console.error(message)
        return false
        // router.push('/404')
      }
    }else{
      logout()
      router.push({
        path:'/login'
      })
    }
    return Promise.reject(error);
  }
);

export default axios;